// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2ths_","containerItemsCenter":"Skeleton_containerItemsCenter__37NaV"};